export default __webpack_public_path__ + "static/media/mouse-control.b8557f9c.svg";